import React, { useEffect } from 'react';

export default function About() {
  useEffect(() => {
    document.title = "À Propos | Tv Plux";
    // Re-initialize jQuery/Swiper plugins after React renders
    if (window.$ && window.$.fn.waypoint) {
      window.$(window).trigger('resize');
    }
    // Re-init Swiper if available
    if (window.Swiper) {
      const swiperEl = document.querySelector('.card__content');
      const swiperFeed = document.querySelector('.card__content_feed');
      if (swiperEl && !swiperEl.swiper) {
        new window.Swiper('.card__content', {
          loop: true, autoplay: { delay: 600 }, centeredSlides: true,
          pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
          breakpoints: { 320: { slidesPerView: 2, spaceBetween: 10 }, 480: { slidesPerView: 2, spaceBetween: 10 }, 640: { slidesPerView: 5, spaceBetween: 15 } }
        });
      }
      if (swiperFeed && !swiperFeed.swiper) {
        new window.Swiper('.card__content_feed', {
          loop: true, autoplay: { delay: 2500 }, centeredSlides: true,
          pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
          breakpoints: { 320: { slidesPerView: 1, spaceBetween: 10 }, 480: { slidesPerView: 1, spaceBetween: 10 }, 640: { slidesPerView: 1, spaceBetween: 15 } }
        });
      }
    }
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: `<!--body overlay -->
    <div class="body-overlay"></div>
    
    <!--main content wrapper start-->
    <div class="main-wrapper">
        
        <!--header area start-->

        

    
        <!--header area end-->
        

        <!--hero section start-->
        <section class="hero-style-1">
            <div class="hero-area overflow-hidden position-relative zindex-1 bg-primary-gradient pt-110">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="hero1-content-wrap">
                                <h1 class="display-font mt-4">Biedt de beste services aan <mark class="position-relative"> IPTV</mark> en Nederland.</h1>
                                <p class="lead mt-4">Het beste IPTV-provider ter wereld !
                                    Tv Nexu is een van de grootste IPTV-providers die ongelooflijke IPTV-abonnementen aanbiedt tegen geweldige prijzen! We zijn een heel team dat uw verzoeken en aankopen beheert en ervoor zorgt dat we een kwaliteitsservice bieden om aan alle behoeften van onze klanten te voldoen. Als je nog geen klant bij ons bent, waar wacht je dan op? Probeer nu onze service!<br class="d-none d-sm-inline-block"/> <mark class="text-warning"></mark></p>
                                <div class="hero-btns mt-5">
                                    <a href="#pricing" class="template-btn primary-btn me-4">Beginnen</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="hero-right">
                                <img src="assets/img/hero-img.jpeg" alt="hero image" />
                            </div>
                        </div>
                    </div>
                </div>
                <img src="assets/img/shapes/hero-right-top.png" alt="rectangle shape" class="right-top position-absolute" />
                <img src="assets/img/shapes/hero-right-bottom.svg" alt="rectangle shape" class="right-bottom position-absolute" />
            </div>
            
        </section>
        <!--hero section end-->

        
        



        <!-- Footer Area -->
         <!-- Footer Area End -->

    </div>
    <!-- main content wrapper ends -->


    <!--build:js-->
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    <!--endbuild-->` }} />
  );
}
